import { Modal, Form, Button, Row, Col } from 'react-bootstrap';

const AddClientModal = ({
    show,
    onHide,
    clientName,
    setClientName,
    emails,
    setEmails,
    phones,
    setPhones,
    logo,
    setLogo,
    address,
    setAddress,
    privateNote,
    setPrivateNote,
    publicNote,
    setPublicNote
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Add New Client</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className='gy-3'>
                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Client Name</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={clientName}
                                    onChange={(e) => setClientName(e.target.value)}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={emails}
                                    onChange={(e) => setEmails(e.target.value)}
                                    placeholder=""
                                />
                                {/* <Form.Text className="p-tag fs-12">
                                    Enter multiple email addresses separated by commas
                                </Form.Text> */}
                            </Form.Group>
                        </Col>

                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={phones}
                                    onChange={(e) => setPhones(e.target.value)}
                                    placeholder=""
                                />
                                {/* <Form.Text className="p-tag fs-12">
                                    Enter multiple phone numbers separated by commas
                                </Form.Text> */}
                            </Form.Group>
                        </Col>

                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Logo</Form.Label>
                                <Form.Control 
                                    type="file" 
                                    onChange={(e) => setLogo(e.target.files[0])}
                                    accept="image/*"
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Address</Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    rows={3}
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Private Note</Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    rows={3}
                                    value={privateNote}
                                    onChange={(e) => setPrivateNote(e.target.value)}
                                    placeholder=""
                                />
                                <Form.Text className="p-tag fs-12">
                                    Enter private notes (only visible to team)
                                </Form.Text>
                            </Form.Group>
                        </Col>

                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Public Note</Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    rows={3}
                                    value={publicNote}
                                    onChange={(e) => setPublicNote(e.target.value)}
                                    placeholder=""
                                />
                                <Form.Text className="p-tag fs-12">
                                    Enter public notes (visible to client)
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onHide}>
                    Add Client
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddClientModal;
